import { notifications } from '@mantine/notifications';
import {
  getPaymentChannelsKey,
  useCreatePaymentChannel,
} from 'api-hooks/payment-channel';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';

import PaymentChannelForm from './components/form';

export default function PaymentChannelCreate() {
  const { navigate, back } = useNavigation();
  const createMutation = useCreatePaymentChannel();
  const permission = useGetCrudPermission('payment-channels');

  return (
    <PaymentChannelForm
      saveMutation={createMutation}
      onSubmit={async (input) => {
        const result = await createMutation.mutateAsync(input);
        queryClient.refetchQueries(getPaymentChannelsKey());
        const prevPath = PreviousNavigation.get();
        if (prevPath) {
          PreviousNavigation.remove();
          back();
        } else if (permission.view) {
          navigate(NavigationRoutes.PaymentChannelsView, {
            id: result.data?.id,
          });
        }
        notifications.show({ message: result?.message, color: 'green' });
        return result.data;
      }}
    />
  );
}
